import React from "react";
import {
  GlassWater, Footprints, Sparkles, Egg, Phone, Coffee, Timer, Wind, Waves, Cherry, Candy, Nut, Clock,
  ScanLine, Search, PenLine, Heart, Moon, Leaf, CupSoda, RefreshCw,
} from "lucide-react";

const MAP = { GlassWater, Footprints, Sparkles, Egg, Phone, Coffee, Timer, Wind, Waves, Cherry, Candy, Nut, Clock, ScanLine, Search, PenLine, Heart, Moon, Leaf, CupSoda, RefreshCw };

export default function DynIcon({ name, ...props }) {
  const I = MAP[name] || Leaf;
  return <I {...props} />;
}
